import React from 'react';

import fetch from './fetch';

import utils from '../utils';

import services from '.';

import {Modal, message, Tag, Tooltip} from 'antd';

const prefixUrl = "roleImport/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};



const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 25
        },
        {
            key: 'roleName',
            label: '角色名称',
            width: 100
        },
        {
            key:'employeeName', 
            label: '职工名称',
            width: 60
        },
        {
            key: 'employeeCode',
            label: '职工工号',
            width: 60
        },
        {
            key: 'status',
            label:  '状态',
            width: 100,
            render: (d) => {
                if (d === 2 || d ===5) {
                    return <Tag color='#2db7f5'>检测通过</Tag>
                } else if (d === 3) {
                    return <Tag color='#f50'>检测不通过</Tag>
                } else if (d === 4 ) {
                    return <Tag color='#87d068'>导入成功</Tag>
                }
            }
        },
        {
            key: 'message',
            label:  '状态描述',
            width: 100,
            render: (d) => {
                return (
                    <Tooltip title={d}>
                        <span>{d}</span>
                    </Tooltip>
                )
            }
        }
    ]
)




// 列表查询
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    // params 为封装分页参数
    let params = []
    const value = services.roles.getSelection();
    keywords.roleId = value[0]
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrl}query?` + params.join('&'), keywords)
    .then(response => {
        if (response.code === 200) {
            return {
                data: response.payload.data,
            }
        }
    })
    .then(res => (
        Object.assign({
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}


// 正式提交
const importAudit = () => {

    const value = services.roles.getSelection();
    const roleId = value[0]

    return fetch.get(`${prefixUrl}submit?roleId=${roleId}`).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).catch(error => {
        return error;
    })
}

// 删除临时数据
const deleteCord = () => {

    const value = services.roles.getSelection();
    const roleId = value[0]
    const ids = DataGrid.selections;

    const params = {
        roleId : roleId,
        ids : ids 
    }

    return fetch.post(`${prefixUrl}deleteCord`,params).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).catch(error => {
        return error;
    })
}


export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    querySearch,
    importAudit,
    columns,
    deleteCord
}